// 初始权限
import { TableName } from "Types/table"

export const InitialPrivilege = {
    get: false,
    insert: false,
    del: false,
    update: false,
}
export function checkUserPrivilege(
    privilegeMap: any,
    tableName: TableName,
    action?: "get" | "update" | "delete" | "insert",
) {
    const privilege = privilegeMap[tableName]
    if (privilege) {
        if (action) {
            return privilege[action]
        } else {
            return privilege
        }
    } else {
        if (action) {
            return false
        } else {
            return InitialPrivilege
        }
    }
}
